import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { useCollisionStore } from '../store/useCollisionStore';
import { ICollisionService } from './ICollisionService';
import { CollisionServiceLogDecorator } from './CollisionServiceLogDecorator';
import { CollisionServiceImpl } from './CollisionServiceImpl';

export class CollisionServiceFactory {
  private static instance: CollisionServiceFactory | null = null;
  private collisionStore: typeof useCollisionStore;
  private floorplanDesignStore: typeof useFloorplanDesignStore;

  public static initialize(
    collisionStore: typeof useCollisionStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    CollisionServiceFactory.instance = new CollisionServiceFactory(
      collisionStore,
      floorplanDesignStore,
    );
  }

  public static getInstance() {
    if (CollisionServiceFactory.instance === null) {
      throw new Error(
        'CollisionServiceFactory not yet initialized. Call CollisionServiceFactory.initialize() first.',
      );
    }
    return CollisionServiceFactory.instance;
  }

  private constructor(
    collisionStore: typeof useCollisionStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    this.collisionStore = collisionStore;
    this.floorplanDesignStore = floorplanDesignStore;
  }

  public createCollisionService(): ICollisionService {
    let result: ICollisionService = this.makeCollisionService();

    result = new CollisionServiceLogDecorator(result);

    return result;
  }

  private makeCollisionService(): ICollisionService {
    return new CollisionServiceImpl(this.collisionStore, this.floorplanDesignStore);
  }
}
